import { SalesOrderContractTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1781. 受注案件契約タスクコメントリアクションtoggle
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  emoji_id: string;
  content: string;
};

const salesOrderContractTaskCommentReaction = (props: Props): Promise<SalesOrderContractTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_comments/${props.id}/reactions`,
    props
  );
};

export const useSalesOrderContractTaskCommentReaction = () => {
  return useMutation({
    mutationFn: salesOrderContractTaskCommentReaction,
  });
};
